import styled from 'styled-components';

export const GalleryContainer = styled.div`
    background: ${props => {
        return props.theme.dark_mode ? '#252525' : '#eee';
    }};
`;
